import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { VideoPlayer } from '@thd-olt-component-react/video-player';
import { Overlay } from '@thd-olt-component-react/overlay';
import { Image as AtomicImage } from '@thd-olt-component-react/image';
import './EtchVisualNav.scss';

const EtchVisualNav = (props) => {
  const { opts = {} } = props;
  const [overlay, setOverlay] = useState(false);
  const [videoId, setVideoId] = useState('');
  const {
    id,
    links = [],
    type
  } = opts;

  const onBtnClick = (event) => {
    const videoId = event.target.getAttribute("data-video");
    if (videoId) {
      event.preventDefault();
      setVideoId(videoId)
      setOverlay(true);
    }
  };

  return (
    <div className="EtchVisualNav" id={id} type={type}>
      <nav className="visualNav__container-sm">
        { links.map(({ image = {}, link, linkText, id: linkId }) => {
          const videoId = (link && link.indexOf('playVideo') > -1) ? link?.match(/(\d+)/gm)?.[0] : '';
          return (<div className="visualNav" link-id={id} key={linkId}>
            {link
            && (
              <>
                <a href={(link && link.indexOf('playVideo') === -1) ? link : '#'} onClick={onBtnClick}>
                  <AtomicImage
                    src={image.src}
                    className="visualNav__img"
                    alt={image.alt}
                    lazy
                    data-video={videoId}
                  />
                </a>
                <a
                  href={(link && link.indexOf('playVideo') === -1) ? link : '#'}
                  className="visualNav__title-center"
                  data-video={videoId}
                  onClick={onBtnClick}
                >{linkText}</a>
              </>
            )}
            {!link
            && (
              <>
                <AtomicImage
                  src={image.src}
                  className="visualNav__img"
                  alt={image.alt}
                  lazy
                  data-video={videoId}
                />
                <p className="visualNav__title-center">{linkText}</p>
              </>
            )}
          </div>)
        })}
      </nav>
      {overlay && (
        <Overlay onClose={() => {setOverlay(false); setVideoId('')}}  open fit closeButton modalClass="etch-widgets__video-overlay__modal">
          <div className="etch-widgets__video-overlay">
            <VideoPlayer videoId={videoId} borderColor="black" autoPlay className="etch-widgets__video-overlay__player" />
          </div>
        </Overlay>
      )}
    </div>
  );
};

EtchVisualNav.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    ctaLink: PropTypes.string,
    heroMedia: PropTypes.object,
    heroMediaMobile: PropTypes.object,
    eventLogo: PropTypes.object,
    eventLogoMobile: PropTypes.object,
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    cta: PropTypes.string,
    collectionLink: PropTypes.string,
    cornerCaption: PropTypes.string,
    type: PropTypes.string
  }).isRequired
};
EtchVisualNav.defaultProps = {
};

export default EtchVisualNav;
